import { render, staticRenderFns } from "./collecExchange.vue?vue&type=template&id=2723a9f0&scoped=true"
import script from "./collecExchange.vue?vue&type=script&lang=js"
export * from "./collecExchange.vue?vue&type=script&lang=js"
import style0 from "./collecExchange.vue?vue&type=style&index=0&id=2723a9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723a9f0",
  null
  
)

export default component.exports